export function isMember(loyaltyProgram, membershipType) {
  if (
    loyaltyProgram &&
    loyaltyProgram.loyaltyCardList &&
    loyaltyProgram.loyaltyCardList.length &&
    loyaltyProgram.loyaltyCardList[0].cardType === membershipType
  ) {
    return true;
  }
  return false;
}
